import { useEffect, useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'

import { JSD_WIDGET_IFRAME_ID } from './constants'
import {
  getLauncherTintBox,
  isCollapsedJsdLauncher,
} from './supportWidgetUtils'

export default function SupportLauncherTint() {
  const [box, setBox] = useState(null)

  useEffect(() => {
    let frame = null
    let resizeObserver

    const place = () => {
      const iframe = document.getElementById(JSD_WIDGET_IFRAME_ID)
      if (iframe !== frame) {
        resizeObserver?.disconnect()
        resizeObserver = undefined
        frame = iframe
        if (iframe && typeof ResizeObserver !== 'undefined') {
          resizeObserver = new ResizeObserver(place)
          resizeObserver.observe(iframe)
        }
      }

      if (!iframe) {
        setBox(null)
        return
      }

      const collapsed = isCollapsedJsdLauncher(
        iframe.offsetWidth,
        iframe.offsetHeight
      )
      iframe.classList.toggle('is-collapsed', collapsed)
      if (!collapsed) {
        setBox(null)
        return
      }

      const next = getLauncherTintBox(iframe.getBoundingClientRect())
      setBox((current) =>
        current &&
        current.left === next.left &&
        current.top === next.top &&
        current.width === next.width
          ? current
          : next
      )
    }

    place()

    const mutation = new MutationObserver((records) => {
      const iframeChanged = records.some((record) =>
        [...record.addedNodes, ...record.removedNodes].some(
          (node) => node.id === JSD_WIDGET_IFRAME_ID
        )
      )
      if (iframeChanged) place()
    })
    mutation.observe(document.body, { childList: true })
    window.addEventListener('resize', place)

    return () => {
      frame?.classList.remove('is-collapsed')
      mutation.disconnect()
      resizeObserver?.disconnect()
      window.removeEventListener('resize', place)
    }
  }, [])

  useLayoutEffect(() => {
    const tint = document.querySelector('.support-widget__launcher-tint')
    if (tint) document.body.appendChild(tint)
  }, [box])

  if (!box || typeof document === 'undefined') return null

  return createPortal(
    <div
      className="support-widget__launcher-tint"
      data-testid="support-widget-launcher-tint"
      aria-hidden="true"
      style={{
        left: `${box.left}px`,
        top: `${box.top}px`,
        width: `${box.width}px`,
        height: `${box.height}px`,
        fontSize: `${box.fontSize}px`,
      }}
    >
      ?
    </div>,
    document.body
  )
}
